import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// import { FormTableComponent } from './form-table/form-table.component';
import { LoginComponent } from './login/login.component';
// import { ProjectformComponent } from './New folder/projectform/projectform.component';
// import { Publishproject2Component } from './New folder/publishproject2/publishproject2.component';
// import { Publishproject3Component } from './New folder/publishproject3/publishproject3.component';
import { CategoryMasterComponent } from './pages/BasicForms/Category/category-master/category-master.component';
import { ClientMasterComponent } from './pages/BasicForms/ClientM/client-master/client-master.component';
import { SchedulelistComponent } from './pages/BasicForms/DailySchedule/schedulelist/schedulelist.component';
import { FeatureMasterComponent } from './pages/BasicForms/Feature/feature-master/feature-master.component';
import { KanbanProjectWiseComponent } from './pages/BasicForms/Kanban/kanban-project-wise/kanban-project-wise.component';
import { KanbanComponent } from './pages/BasicForms/Kanban/kanban/kanban.component';
import { ModuleMasterComponent } from './pages/BasicForms/ModuleM/module-master/module-master.component';
import { ProjectMasterComponent } from './pages/BasicForms/ProjectM/project-master/project-master.component';
import { RoadmapComponent } from './pages/BasicForms/roadmap/roadmap.component';
import { TaskMasterComponent } from './pages/BasicForms/TaskM/task-master/task-master.component';
import { TaskTransferHistoryComponent } from './pages/BasicForms/taskTransfer/task-transfer-history/task-transfer-history.component';
import { TypeMasterComponent } from './pages/BasicForms/Type/type-master/type-master.component';

import { AdmindashboardComponent } from './pages/CommonModule/admindashboard/admindashboard.component';
import { FormsComponent } from './pages/CommonModule/Forms/forms/forms.component';
import { RolesComponent } from './pages/CommonModule/Roles/roles/roles.component';
import { UsersComponent } from './pages/CommonModule/Users/users/users.component';
import { DetaildWorklogReportComponent } from './pages/Reports/detaild-worklog-report/detaild-worklog-report.component';
import { EfficiencyComponent } from './pages/Reports/efficiency/efficiency.component';
import { EmployeeHoursReportComponent } from './pages/Reports/employee-hours-report/employee-hours-report.component';
import { EmployeeProjectWiseComponent } from './pages/Reports/employee-project-wise/employee-project-wise.component';
import { ProjectWiseDetailsComponent } from './pages/Reports/project-wise-details/project-wise-details.component';
import { ProjectWiseEmployeeDetailsComponent } from './pages/Reports/project-wise-employee-details/project-wise-employee-details.component';
import { ProjectWiseSummaryComponent } from './pages/Reports/project-wise-summary/project-wise-summary.component';
import { ProjectWiseWorkingHoursComponent } from './pages/Reports/project-wise-working-hours/project-wise-working-hours.component';
import { UserWiseDetailedWithoutTaskSubtaskComponent } from './pages/Reports/user-wise-detailed-without-task-subtask/user-wise-detailed-without-task-subtask.component';
import { UserWiseDetailedComponent } from './pages/Reports/user-wise-detailed/user-wise-detailed.component';
// import { ProjectformComponent } from './projectform/projectform.component';
// import { Publishproject2Component } from './publishproject2/publishproject2.component';
// import { Publishproject3Component } from './publishproject3/publishproject3.component';
import { PmsgiantreportComponent } from './Reports/pmsgiantreport/pmsgiantreport.component';
import { ViewPmsWorkLogComponent } from './pages/BasicForms/PmsWorkLog/view-pms-work-log/view-pms-work-log.component';
import { EmployeePhaseTimeCompensationReportComponent } from './pages/Reports/employee-phase-time-compensation-report/employee-phase-time-compensation-report.component';
import { MonthlyBillingComponent } from './pages/Reports/monthly-billing/monthly-billing.component';
import { BillReportComponent } from './pages/Reports/billReport/bill-report/bill-report.component';
import { EmployeeTimeUtilizationReportComponent } from './pages/Reports/employee-time-utilization-report/employee-time-utilization-report.component';
import { EvaluationReportComponent } from './pages/Reports/evaluation-report/evaluation-report.component';
import { ProjectDetailsMasterComponent } from './pages/CommonModule/project-master/project-master.component';
import { UserListComponentComponent } from './pages/CommonModule/user-list-component/user-list-component.component';
import { MonthlyBillingGetPreviewComponent } from './pages/Reports/monthly-billing-get-preview/monthly-billing-get-preview.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/projects' },
  {
    path: 'welcome',
    loadChildren: () =>
      import('./pages/welcome/welcome.module').then((m) => m.WelcomeModule),
  },
  { path: 'login', component: LoginComponent },
  { path: 'forms', component: FormsComponent },
  { path: 'users', component: UsersComponent },
  { path: 'roles', component: RolesComponent },

  { path: 'clients', component: ClientMasterComponent },
  { path: 'projects', component: ProjectMasterComponent },
  { path: 'modules', component: ModuleMasterComponent },
  { path: 'features', component: FeatureMasterComponent },
  { path: 'category', component: CategoryMasterComponent },
  { path: 'tasks', component: TaskMasterComponent },
  { path: 'type', component: TypeMasterComponent },
  { path: 'kanban', component: KanbanComponent, children: [] },
  { path: 'projectID/:id', component: KanbanProjectWiseComponent },
  { path: 'roadmap', component: RoadmapComponent },

  { path: 'EmployeeWorklogReport', component: EmployeeHoursReportComponent },
  { path: 'EmployeeProjectWise', component: EmployeeProjectWiseComponent },
  { path: 'ProjectWiseReport', component: ProjectWiseWorkingHoursComponent },
  { path: 'ShortDayWiseReport', component: UserWiseDetailedComponent },
  {
    path: 'DetailedReport',
    component: UserWiseDetailedWithoutTaskSubtaskComponent,
  },
  {
    path: 'ProjectWiseSummaryReport',
    component: ProjectWiseEmployeeDetailsComponent,
  },
  { path: 'efficiency', component: EfficiencyComponent },
  { path: 'DetailedWorklogReport', component: DetaildWorklogReportComponent },

  { path: 'ProjectWiseSummary', component: ProjectWiseDetailsComponent },
  {
    path: 'ProjectWiseSubtaskDetailedSummary',
    component: ProjectWiseSummaryComponent,
  },

  { path: 'attachment', component: TaskTransferHistoryComponent },
  { path: 'index', component: AdmindashboardComponent },
  { path: 'dailyschedule', component: SchedulelistComponent },

  // { path: 'drawerForm', component: ProjectformComponent },
  //   {path:'publish1',component:Publishproject1Component},
  // { path: 'pendingpublish', component: Publishproject2Component },
  // { path: 'pendingtesting', component: Publishproject3Component },
  { path: 'daywisesubtaskreports', component: PmsgiantreportComponent },
  { path: 'work_log', component: ViewPmsWorkLogComponent },


  {
    path: 'Employee-Compensation-Report',
    component: EmployeePhaseTimeCompensationReportComponent,
  },

  {
    path: 'MonthlyBillingPreviewReport',
    component: MonthlyBillingGetPreviewComponent,
  },
  {
    path: 'timeutilizationreport',
    component: EmployeeTimeUtilizationReportComponent,
  },
  { path: 'MonthlyBilling', component: MonthlyBillingComponent },
  { path: 'yearly_bill_report', component: BillReportComponent },
  { path: 'evaluation_report', component: EvaluationReportComponent },
  { path: 'projectsdetails', component: ProjectDetailsMasterComponent },
  { path: 'User_Detail', component: UserListComponentComponent },
  // {
  //   path: 'Employee_Wise_Project_Billing',
  //   component: EmployeePhaseTimeCompensationReportComponent,
  // },
  // {
  //   path: 'Published_Employee_Wise_Billing',
  //   component: EmployeeTimeUtilizationReportComponent,
  // },
  // { path: 'Project_Wise_Monthly_Billing', component: MonthlyBillingComponent },
  // { path: 'Project_Wise_Yearly_Billing', component: BillReportComponent },
  // { path: 'Employee_Daily_Worklog', component: EvaluationReportComponent },
  // { path: 'ProjectList', component: ProjectDetailsMasterComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
